export const Logo = ({ className = "", intro = false }) => (
  <span className={`relative inline-flex items-start font-display font-extrabold leading-none select-none ${intro ? "logo-intro" : ""} ${className}`} aria-label="NEXUS®">
    <span className="logo-word">NEXUS</span>
    <svg className="logo-r" viewBox="0 0 40 40" aria-hidden="true">
      <defs>
        <linearGradient id="nexus-r-gold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#f3dc9c" />
          <stop offset=".5" stopColor="#d4af5a" />
          <stop offset="1" stopColor="#a8853b" />
        </linearGradient>
      </defs>
      <circle cx="20" cy="20" r="17.5" fill="none" stroke="url(#nexus-r-gold)" strokeWidth="3" />
      <path d="M14 29V11h7.2c3.9 0 6.3 2 6.3 5.3 0 2.5-1.4 4.2-3.7 4.9L28.2 29h-4.1l-4-7.4h-2.4V29zm3.7-10.4h3.3c1.9 0 2.9-.8 2.9-2.3s-1-2.3-2.9-2.3h-3.3z" fill="url(#nexus-r-gold)" />
    </svg>
  </span>
);
